export const homeContent = {
  hero: {
    title: "A Seat for the Soil at the Big Business Table",
    subheadline: "We are aligning the mentality of environmentalism with the action of putting money in the hands of regenerative land managers.",
    description: "Earth Rights Business is a movement about creating a seat for the soil at the big business table."
  },
  problem: {
    title: "Art That Speaks for the Soil",
    text: "ERB creates collectible alphabet art—digital and physical—that does more than decorate. Each piece you own is a voice in a growing movement to regenerate Earth's soil.",
    items: [
      "Join a movement funding soil regeneration",
      "Own first-edition collectible art (limited supply)",
      "Become part of the founding community",
      "Use a decentralized technology to address a global issue",
      "Support the creation of a regenerative business certification"
    ],
    products: "NFT — 0.23 SOL | Digital art on Solana blockchain\nPhysical — $100 | Laser-cut wooden art piece"
  },
  invitation: {
    title: "The Soil Cycle of Value",
    quote: "This is not a message in a bottle. This is a message in a business model.",
    secondaryQuote: "We are a community demonstrating how to use the power of words to direct dollars into businesses that nurture nature.",
    steps: [
      {
        title: "YOU COLLECT",
        description: "Purchase alphabet art. Each piece is your stake in potentially massive movement."
      },
      {
        title: "THE MOVEMENT GROWS",
        description: "More collectors = stronger voice = greater impact."
      },
      {
        title: "SOIL REGENERATES",
        description: "Resources flow to regenerative farms and certified businesses."
      }
    ]
  },
  vision: {
    title: "Where We're Going",
    phases: [
      {
        title: "PHASE 1: BUILD THE MOVEMENT",
        status: "We are here",
        description: "Grow the community of believers through art, message, and shared values while funding regenerative farms."
      },
      {
        title: "PHASE 2: CREATE CERTIFICATION",
        description: "Develop a certification system for businesses by consumers committed to regenerating soil."
      },
      {
        title: "PHASE 3: SUPPORT & LOOP",
        description: "Fund certified businesses. Create economic loops that create long lasting business relationships."
      }
    ]
  },
  closing: {
    quote: "An offering is the antidote to the extractive mind",
    description: "A way to make money helping the soil get filthy rich."
  }
};